import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';
import { FontAwesomeIcon as FAIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import uuid4 from 'uuid';
import Spinner from '../../Spinner/Spinner';

const Container = styled.form`
  display: grid;
  grid-template-rows: auto;
  grid-gap: 0.5rem;

  input {
    width: 100%;
    font-weight: bold;
    padding: 0.5rem 0;
    font-size: 1rem;
    border: none;
    border-bottom: ${props => (!props.error ? '2px solid var(--color-lighter)' : '2px solid var(--color-red)')};

    &:focus {
      outline: none;
    }

    ::-webkit-input-placeholder,
    ::-moz-placeholder,
    :-ms-input-placeholder,
    :-moz-placeholder,
    ::placeholder {
      color: var(--color-faded);
      font-weight: normal;
    }
  }

  label {
    position: relative;
  }
`;

const FeedbackContainer = styled.div`
  position: absolute;
  top: 40%;
  right: 0;

  ${Spinner} {
    width: 2em;
    height: 2em;
  }

  svg {
    color: var(--color-red);
  }
`;

const ErrorMessage = styled.p`
  color: var(--color-red);
  font-size: 0.8rem;
  filter: opacity(0.8);
`;

const ErrorContainer = styled.div`
  min-height: 1.1rem;
  visibility: hidden

  ${props => props.show
    && css`
      visibility: initial;
    `};
`;

const Form = ({
  changeEmailValue, emailState, isValidationError, errorMessages, showErrors,
}) => {
  const { value, updating, error } = emailState;

  const handleKeyPress = useCallback((e) => {
    if (e.key === 'Enter') {
      // We only need to prevent this event from propagating further and lose focus from input
      // Value update happens automatically on change with 1 sec delay
      e.preventDefault();
      e.target.blur();
    }
  }, []);

  return (
    <Container error={isValidationError || errorMessages.length > 0}>
      <label htmlFor="email" onSubmit={e => e.preventDefault()}>
        <p>E-Mail*</p>
        <input
          type="text"
          id="email"
          name="email"
          placeholder="email@xyz.ch"
          value={value}
          onChange={e => changeEmailValue(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <ErrorContainer show={showErrors}>
          {errorMessages.map(message => (
            <ErrorMessage key={uuid4()}>{message.detail}</ErrorMessage>
          ))}
        </ErrorContainer>
        {updating && (
          <FeedbackContainer>
            <Spinner />
          </FeedbackContainer>
        )}
        {error && (
          <FeedbackContainer>
            <FAIcon icon={faTimes} />
          </FeedbackContainer>
        )}
      </label>
    </Container>
  );
};

export default Form;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Form/Form.jsx